import SecurityImg from './security.svg';

type ImageProps = React.JSX.IntrinsicElements['div'] & {
  width?: string;
  alt?: string;
}

export const SecurityIcon = ({width = "32px", alt = "Bank icon", ...props}: ImageProps) => <div {...props}><img src={SecurityImg} width={width} alt={alt} /></div>
export default SecurityIcon;